
let inject = [
    '$scope',
    'eventDetailService',
    'SharedService',
    '$stateParams',

];

class EventDetailController {
    constructor($scope,eventDetailService,SharedService,$stateParams) {
        this.eventDetailService=eventDetailService;
        this.$stateParams=$stateParams;
        this.SharedService=SharedService;
        this.$scope = $scope;
        this.event=[];
        this.eventId = this.$stateParams.eventId || '';
        this.pageName = "B2B-PAG-42";


        this.SharedService.getCMSBanners(this.pageName).then(response => {
          this.cmsData = response;
        });
    }

    $onInit() {
      this.eventDetailService.getEvent(this.$stateParams.eventId).then(response=>{
        this.event=response.data[0];


      });
    }



}

EventDetailController.$inject = inject;

export default EventDetailController;




/** WEBPACK FOOTER **
 ** ./www/components/catalog/events/event-detail/event-detail.controller.js
 **/